<template>
  <v-app id="app">
    <v-app-bar
      :class="`fin-public-app-bar ${$vuetify.breakpoint.smAndDown ? '': 'px-6'} fin-color-primary-dark fin-color-primary-light--text fin-box-shadow-lg`"
      app
      dark
      height="70"
      style="z-index: 20 !important;">

      <v-toolbar-title class="pr-8">
        <router-link id="navHomeLink" to="/home">
          <fin-logo-full :dark="false"
                         :size="this.$valueByBreakpoint({ xs: '105', sm: '133' })"/>
        </router-link>
      </v-toolbar-title>

      <v-spacer/>

      <fin-sign-out-btn/>
    </v-app-bar>

    <v-main :style="{backgroundColor: $finColors.primaryDark, color: $finColors.primaryLight}">
      <v-container :class="$vuetify.breakpoint.xs ? 'pa-3' : 'pa-6'" fill-height>
        <v-row>
          <v-col cols="12" md="2" offset-lg="1" offset-xl="2" sm="12">
            <h4 class="mb-1">Erstelle dein erstes Musterportfolio</h4>
            <p style="max-width: 500px;">Wir helfen dir Schritt für Schritt in wenigen Minuten zu einem auf dich
              zugeschnittenen Portfolio zu gelangen. Du kannst das Onboarding aber auch später noch nachholen.</p>
          </v-col>

          <v-col cols="12" lg="4" md="5" sm="6" xl="3">
            <fin-onboarding-fast-track-card :button-action="{ name: 'onbgetstarted', params: { from: 'ft' } }"
                                            :info-text="infoText"
                                            id="fastTrackOnb"
                                            :button-label="userOnboardingData.step1 && userOnboardingData.currentState > 0 ? 'Onboarding fortsetzen' : 'Onboarding starten'"
                                            header="Schritt für Schritt zu deinem Musterportfolio"
                                            image="card1.png"/>
          </v-col>

          <v-col :align-self="$vuetify.breakpoint.mdAndUp ? 'center' : 'start'" cols="12" lg="4" md="5" sm="6" xl="3">
            <fin-onboarding-fast-track-card :button-action="{ name: 'myFinHub' }"
                                            id="fastTrackSkip"
                                            :header-image-in-row="$vuetify.breakpoint.xs"
                                            :image-overlapping="$vuetify.breakpoint.mdAndUp"
                                            background-color="#0E154E"
                                            button-label="Direkt zum Dashboard"
                                            button-outlined
                                            header="Nein danke, Onboarding überspringen"
                                            image="card2.png"
                                            max-width="415px"
                                            @fastTrackButtonClicked="skipInitialOnboarding"
                                            small-header="Für Fortgeschrittene"/>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import FinLogoFull from "@/components/common/logo/LogoFull"
import FinOnboardingFastTrackCard from "@/components/pages/onboarding/FastTrackCard"
import FinSignOutBtn from "@/components/auth/SignOutBtn"
import {mapActions, mapGetters} from "vuex"

export default {
  name: "FinOnboardingFastTrack",
  components: {
    FinSignOutBtn,
    FinLogoFull,
    FinOnboardingFastTrackCard
  },
  data() {
    return {
      infoText: `<h2 class="header pb-6">Schritt für Schritt zu deinem Musterportfolio</h2>
        <p>Diese Variante solltest du wählen, wenn</p>
        <ul>
            <li>du noch keine oder wenig Erfahrung an der Börse hast</li>
            <li>du noch Unterstützung und Hilfestellungen benötigst</li>
            <li>du dich bisher noch nicht mit deinem Anlegerprofil auseinandergesetzt hast</li>
            <li>du dich bisher nicht sicher fühlst, dir selbst Strategien und Asset Allokationen zu überlegen</li>
        </ul>`,
    }
  },
  computed: {
    ...mapGetters('auth', ['userOnboardingData']),
  },
  methods: {
    ...mapActions('auth', ['updateOnboarding']),
    async skipInitialOnboarding() {
      this.userOnboardingData.initialOnboardingFinished = true
      const jsonVal = JSON.stringify(this.userOnboardingData) || '{}'
      await this.updateOnboarding(jsonVal).catch(error => {
        console.error("Error setting initialOnboardingFinished after skipping to dashboard", error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  font-family: $body-font-family;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 22px;
  color: $fin-color-primary-light;
}

p {
  font-family: $body-font-family;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: $fin-color-primary-light;
  /* additional */
  hyphens: none;

  @media only screen and (max-width: 600px) {
    font-size: 14px;
    line-height: 19px;
  }
}
</style>
